
export default {
  name: 'NoResultsOffer',

  props: {
    banner: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      steps: 4
    }
  }
}
